import {
  TypedForm,
  ObjectSchema,
  string,
  object,
  array,
  date,
} from 'libs/form';
import { TFunc } from 'libs/i18n';
import {
  getToday,
  getTodayWithResetHours,
  localFileScheme,
} from 'modules/client/common/helpers';
import { Maybe } from 'types/maybe';

import { LocalFileEntity } from '../types';

export interface BasisForRepresentationFormType {
  basisForRepresentation: {
    documentName: string;
    documentNumber?: Maybe<string>;
    dateOfIssue: Date;
    dateOfExpiration: Date;
    files: LocalFileEntity[];
    notaryFullName?: string;
    notaryLicenseInfo?: string;
  };
}

export const getBasisForRepresentationSchema = (
  t: TFunc
): ObjectSchema<BasisForRepresentationFormType> =>
  object({
    basisForRepresentation: object({
      documentName: string().required().max(200),
      documentNumber: string().max(200),
      dateOfIssue: date().max(getToday(), t('validation.maxDate')).required(),
      dateOfExpiration: date()
        .min(getTodayWithResetHours(), t('validation.minDate'))
        .required(),
      files: array().of(localFileScheme).required().min(1),
      notaryFullName: string().max(200),
      notaryLicenseInfo: string().max(200),
    }),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<BasisForRepresentationFormType>();
